// Auto Trigger clicks based on
// - scroll (% of page scrolled; minimum 5, default 5)
// - time (seconds spent on the page; minimum 1, default 1)
// - exit intent (always on)
//
// whichever happens first triggers the click, once per page load
//
// usage:
// - attach to an element with a click interaction
//    eg: <button data-autotrigger-click>
//
// - configure trigger parameters
//    eg: <… data-autotrigger-click data-autotrigger-scroll=15> (% of page that should be scrolled)
//    eg: <… data-autotrigger-click data-autotrigger-time=10> (seconds to be spent on the page)

(function () {
  'use strict';

  const selectors = {
    trigger: '[data-autotrigger-click]',
    scrollAttr: 'autotriggerScroll',
    timeAttr: 'autotriggerTime',
  };

  function initAutoTriggers() {
    document.querySelectorAll(selectors.trigger).forEach(function (trigger) {
      let scrollThreshold = parseFloat(trigger.dataset[selectors.scrollAttr]);
      let timeThreshold = parseFloat(trigger.dataset[selectors.timeAttr]);

      if (isNaN(scrollThreshold) || scrollThreshold < 5) {
        scrollThreshold = 5;
      }
      if (isNaN(timeThreshold) || timeThreshold < 1) {
        timeThreshold = 1;
      }
      setupAutoTrigger(trigger, scrollThreshold, timeThreshold);
    });
  }

  function setupAutoTrigger(trigger, scrollThreshold, timeThreshold) {
    let scrolled = false;
    let stayed = false;
    let exitIntent = false;

    // Trigger on scroll
    let checkScroll = function () {
      let parentElement = document.body.parentNode;
      let scrollTop = document.body.scrollTop || parentElement.scrollTop;
      let scrollPercent =
        (scrollTop /
          (parentElement.scrollHeight - parentElement.clientHeight)) *
        100;

      if (!scrolled && scrollPercent > scrollThreshold) {
        scrolled = true;
        showLightbox();
      }
    };

    // Trigger on time spent on the page
    let stayTimeout = setTimeout(function () {
      stayed = true;
      showLightbox();
    }, timeThreshold * 1000);

    // Trigger on exit intent
    let checkExitIntent = function (e) {
      if (!exitIntent && e.relatedTarget === null && e.clientY <= 10) {
        exitIntent = true;
        showLightbox();
      }
    };

    let showLightbox = function () {
      if (scrolled || stayed || exitIntent) {
        trigger.click();
        cleanup();
      }
    };

    let cleanup = function () {
      clearTimeout(stayTimeout);
      window.removeEventListener('scroll', checkScroll);
      document.removeEventListener('mouseleave', checkExitIntent);
    };

    window.addEventListener('scroll', checkScroll);
    document.addEventListener('mouseleave', checkExitIntent);
  }

  initAutoTriggers();
})();
